import {
   clsx
  ,Box
} from 'external/material'
import { useMemo} from 'external/react'
import {PreviewIcon, DownloadIcon, MessageIcon, SquareArrowUpRightIcon} from 'resources/icons'
import {viewerGuard, subdomainLink} from 'utils/url'
import {inViewer} from 'settings'
import { logLessonAccess } from 'utils/lesson'

import useTranslations from 'hooks/translations'
import useProfile from 'hooks/profile'

export default function LessonLinks(props) {
  const {institution} = useProfile()
  const {language} = useTranslations()
  const {hasEpl, id, scheduled, downloaded} = props

  const showLink = useMemo(() => {
    return (institution && institution.location && institution.location.toLowerCase() === 'rd') || scheduled
  }, [scheduled, institution])

  return (<Box className="lessonLinks">
    {hasEpl && <a
      className={clsx("lessonLink", "online")}
      onClick={logLessonAccess('online', props)}
      {...viewerGuard({target: "_blank", href: subdomainLink('preview', '#',  language, 'lesson', id)})}
    ><PreviewIcon fill="#2c75bd" width={25} /></a>}
    {props.onMessageClick && <span onClick={e => {
      props.onMessageClick(e.currentTarget)
    }} className={clsx("lessonLink", "message")}><MessageIcon fill="#2c75bd" width={21} /></span>}
    {hasEpl && inViewer && showLink && downloaded && <a className={clsx("lessonLink", "view")} href={`//downloads/${id}`}><SquareArrowUpRightIcon fill="#2c75bd" height={20} /></a>} 
    {hasEpl && inViewer && showLink && !downloaded && <a
      className={clsx("lessonLink", "download")}
      onClick={logLessonAccess('download', props)}
      {...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'download', `?lesson=${id}`)})}
    ><DownloadIcon fill="#2c75bd" width={17} /></a>}
    </Box>)
}
